<template>
    <div class="foodhealth-section">
        <div class="header w1200 clearfix">
            <div class="header-left">
                <div class="hr"></div>
                <h2>食品健康</h2>
                <h3>SINCE 1961</h3>
            </div>
            <div class="header-right">Food Health</div>
        </div>
        <div class="p-div w1200">
            <div class="left">
                <p>在Kids 'R' Kids在中国的幼儿园大家庭，我们希望让孩子得到和在家庭里一样、甚至比家里还要更科学的营养健康饮食。我们严格控制食物来源、卫生处理及烹饪做法，确保KRK的孩子享受到安全、营养及新鲜的食物。</p>
                <p class="footnote">
                    <span class="hr"></span>
                    <span class="text">FOOD HEALTH</span>
                </p>
            </div>
            <div class="right bg1">
                <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/food_img1.jpg">
            </div>
        </div>
        <div class="p-div2">
            <div class="w1200">
                <div class="left">
                    <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/food_img2.jpg">
                </div>
                <div class="right">
                    <p>出于营养健康的角度，我们所有的菜单均会经由专业营养师评估，专门针对孩子的口味推出美味创新且营养的菜谱，给孩子多种选择，适应不同孩子的需求。我们给孩子准备的食品当中绝不含有坚果、味精和调和油，同时也避免使用过量的盐糖，不使用花生油及蚕豆，烹饪过程中只使用天然香料增加食物风味，并且限制油炸食品的供应。</p>
                    <p class="footnote">
                        <span class="hr"></span>
                        <span class="dot"></span>
                        <span class="dot"></span>
                    </p>
                </div>
            </div>
        </div>
        <div class="p-div w1200 div3">
            <div class="left">
                <p>为了确保食品新鲜，在Kids 'R' Kids QA标准的审核下，经过严格消毒的幼儿园厨房和餐厅，采购新鲜、健康、安全的食材，安排专业厨房团队为孩子准备健康、美味的餐点，让孩子在KRK幼儿园也可以获得有如在家庭中的爱的呵护。</p>
                <p class="footnote">
                    <span class="hr"></span>
                    <span class="text">FOOD HEALTH</span>
                </p>
            </div>
            <div class="right">
                <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/food_img3.jpg">
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  components: {},
  methods: {}
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.foodhealth-section{
    width: 100%;
    margin: 0 auto;
    background: rgba(255,255,255,1);
    .w1200{
        width:1200px !important;
        margin:0 auto;
    }
    .header{
        height: 155px;
        overflow: hidden;
        margin-top: 110px;
        margin-bottom: 15px;
        .header-left{
            float: left;
            .hr{
                width:96px;
                height:4px;
                background:rgba(174,149,79,1);
            }
            h2{
                width: 375px;
                height: 96px;
                font-size: 48px;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                color: #333333;
                line-height: 96px;
            }
            h3{
                width:180px;
                height:29px;
                line-height: 29px;
                background:rgba(174,149,79,1);
                font-size:24px;
                font-family:TimesNewRomanPS-BoldItalicMT;
                font-weight: bold;
                font-style:italic;
                color:rgba(255,255,255,1);
                text-align: center;
            }
        }
        .header-right{
            float: right;
            width: 400px;
            margin-top: 16px;
            // margin-left: 430px;
            height: 73px;
            font-size: 73px;
            font-family: TimesNewRomanPS-ItalicMT;
            font-style: italic;
            color: rgba(204,204,204,1);
            line-height: 73px;
            text-align: right;
        }
    }
    .p-div{
        clear:both;
        height: 353px;
        padding-bottom: 137px;
        overflow: hidden;
        .left{
            float: left;
            width: 566px;
            margin-top: 86px;
            margin-left: 65px;
            p{
                width: 566px;
                height: 231px;
                font-size: 16px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                color: rgba(51,51,51,1);
                line-height: 30px;
            }
            p.footnote{
                text-align: right;
                height: 12px;
                line-height: 12px;
                span{
                    display: inline-block;
                    height:10px;
                    font-size:12px;
                    font-family:PingFangSC-Regular;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                }
                span.hr{
                    display: inline-block;
                    width:120px;
                    height:1px;
                    background:rgba(153,153,153,1);
                    margin: 3px 18px;
                }
            }
        }
        .right{
            float:left;
            margin-left: 37px;
            img{
                width:531px;
                height:351px;
            }
        }
    }
    .p-div2{
        clear: both;
        height: 541px;
        background:url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/food_bg.jpg) no-repeat;
        .left{
            float: left;
            width: 376px;
            height: 490px;
            img{
                position: relative;
                width: 100%;
                height: 100%;
                top: 22px;
                left: 65px;
            }
        }
        .right{
            float: left;
            margin-top: 65px;
            margin-left: 65px;
            width: 707px;
            height: 405px;
            background: #fff;
            p{
                width: 580px;
                height: 268px;
                padding-left: 53px;
                padding-top: 90px;
                font-size: 16px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                line-height: 30px;
                color: rgba(51,51,51,1);        
            }
            p.footnote{
                padding-top:0;
                height:12px;
                line-height:12px;
                text-align: right;
                span{
                    display: inline-block;
                    height:10px;
                    font-size:12px;
                    font-family:PingFang;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                }
                span.hr{
                    display: inline-block;
                    width: 109px;
                    height: 2px;
                    margin-right:6px;
                    background: rgba(14,64,130,1);
                }
                span.dot{
                    display: inline-block;
                    width:6px;
                    height:6px;
                    background:rgba(14,64,130,1);
                    border-radius:3px;
                    margin-left:7px; 
                    margin-top: 7px;                   
                }
            }
        }
    }
    .p-div.div3{
            padding-top: 125px;
            padding-bottom: 126px;
            height: auto;
        .left{
            h2{
                height:25px;
                font-size:24px;
                font-family:PingFangSC-Regular;
                font-weight: bold;
                color:rgba(51,51,51,1);
                line-height:36px;
                margin-bottom:43px;
            }
            p{
                width:550px;
                height:217px;
                span.hr{
                    margin:3px 28px;
                }
            }
            p.footnote{
                height:10px;
                line-height: 10px;
                text-align: left;
                direction: rtl;
            }
        }
        .right{
            img{
                position: static;
                width:530px;
                height:350px;
            }
        }
    }
}
@media (max-width: 767px) {
.foodhealth-section {
  .w1200 {
    width: 100% !important;
    height: 65px;
  }
  .header {
    width: 100%;
    overflow: hidden;
    margin: 35px 0;
    .header-left {
      width: 100%;
      box-sizing: border-box;
      padding-left: 7.1%;
      .hr {
        width: 56px;
        height: 3px;
        background:rgba(174,149,79,1);
      }
      h2 {
        width: 100%;
        height: 41px;
        font-size: 21px;
        font-weight: 500;
        color: #333333;
        line-height: 25px;
        font-family: PingFangSC-Medium;
        padding: 10px 0 8px;
        box-sizing: border-box;
      }
      h3 {
        width: 64px;
        height: 20px;
        font-size: 10px;
        font-family: TimesNewRomanPS-BoldItalicMT;
        font-weight: normal;
        line-height: 20px;
        background: rgba(174, 149, 79, 1);
        font-style: italic;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        padding: 0 5px;
      }
    }
    .header-right {
      display: none;
    }
  }
  .p-div {
    clear: both;
    width: 100%;
    height: 339px;
    padding-bottom: 0;
    display: flex;
    flex-direction: column-reverse;
    .left {
      clear: both;
      width: 100%;
      margin-top: 0;
      margin-left: 0;
      p {
        width: 100%;
        box-sizing: border-box;
        padding: 21px 9.5% 0 7.9%;
        height: 127px;
        font-size: 13px;
        line-height: 21px;
      }
      p.footnote {
        display: none;
      }
    }
    .right {
      clear: both;
      margin-left: 0;
      width: 100%;
      padding: 0 7.5%;
      box-sizing: border-box;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
  .p-div2 {
    clear: both;
    height: 217px;
    background: url(https://krk-website.oss-cn-beijing.aliyuncs.com/img/food_bg.jpg)
      no-repeat;
    background-size: 100% 217px;
    margin-top: 56px;
    .left {
      float: left;
      box-sizing: border-box;
      width: 100%;
      padding: 0 16.6% 0 15.7%;
      height: auto;
      margin-top: -28px;
      img {
        position: initial;
        width: 100%;
        height: auto;
      }
    }
    .right {
      float: left;
      margin-top: 0;
      margin-left: 0;
      width: 100%;
      height: 186px;
      margin-bottom: 62px;
      p {
        width: 100%;
        height: 186px;
        padding: 17px 16.8% 0 15.9%;
        font-size: 13px;
        line-height: 21px;
        box-sizing: border-box;
      }
      p.footnote {
        display: none;
      }
    }
  }
  .p-div.div3 {
    clear: both;
    width: 100%;
    height: auto;
    padding: 0;
    display: flex;
    flex-direction: column-reverse;
    margin-bottom: 35px;
    margin-top: 62px;
    .right {
      clear: both;
      margin-left: 0;
      width: 100%;
      padding: 0 7.5%;
      box-sizing: border-box;
      img {
        width: 100%;
        height: auto;
      }
    }
    .left {
      p {
        width: 100%;
        box-sizing: border-box;
        padding: 21px 9.5% 7.9%;
        height: 127px;
        font-size: 13px;
        line-height: 21px;
      }
      p.footnote {
        display: none;
      }
    }
  }
}
}
</style>


// WEBPACK FOOTER //
// src/pages/choose/foodhealth.vue